import { Component, Prop } from 'vue-property-decorator';
import Vue, { CreateElement } from 'vue';
@Component
export default class AMSformTable extends Vue {
  @Prop() row!: any;
  @Prop() renderFunction!: Function;
  @Prop() index!: string;
  @Prop() keyName!: string;

  render(h: CreateElement) {
    const params = {
      row: this.row,
      index: this.index,
      keyName: this.keyName
    };
    return this.renderFunction(h, params);
  }
}
